import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "user-form-container" }
const _hoisted_2 = {
  key: 0,
  class: "user-form-content"
}
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "ar-field" }
const _hoisted_5 = { class: "formlabel" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "ar-error"
}
const _hoisted_8 = {
  key: 1,
  class: "ar-error"
}
const _hoisted_9 = { class: "ar-field" }
const _hoisted_10 = { class: "formlabel" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "ar-error"
}
const _hoisted_13 = {
  key: 1,
  class: "ar-error"
}
const _hoisted_14 = { class: "ar-field" }
const _hoisted_15 = { class: "formlabel" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = {
  key: 0,
  class: "ar-error"
}
const _hoisted_18 = {
  key: 1,
  class: "ar-error"
}
const _hoisted_19 = { class: "ar-field" }
const _hoisted_20 = { class: "formlabel" }
const _hoisted_21 = {
  key: 0,
  class: "ar-error"
}
const _hoisted_22 = {
  key: 1,
  class: "ar-error"
}
const _hoisted_23 = { class: "ar-field" }
const _hoisted_24 = { class: "formlabel" }
const _hoisted_25 = {
  key: 0,
  class: "ar-error"
}
const _hoisted_26 = {
  key: 1,
  class: "ar-error"
}
const _hoisted_27 = {
  key: 0,
  class: "form-section"
}
const _hoisted_28 = { class: "ar-field checkbox" }
const _hoisted_29 = {
  key: 0,
  class: "ar-field"
}
const _hoisted_30 = { class: "formlabel" }
const _hoisted_31 = ["placeholder"]
const _hoisted_32 = { class: "ar-field checkbox" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Ich habe die ")
const _hoisted_34 = ["target"]
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" gelesen und akzeptiere sie.*")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = {
  key: 0,
  class: "ar-error"
}
const _hoisted_38 = { class: "ar-field checkbox" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Ich habe die ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" von ALPrelax gelesen und akzeptiere diese.*")
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = {
  key: 0,
  class: "ar-error"
}
const _hoisted_43 = { class: "ar-field checkbox" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "ar-field text text-align-right" }, [
  /*#__PURE__*/_createElementVNode("p", null, "*) Pflichtfelder")
], -1)
const _hoisted_45 = { class: "switch-form" }
const _hoisted_46 = {
  key: 1,
  class: "user-form-content"
}
const _hoisted_47 = { class: "user-created-success-container" }
const _hoisted_48 = { class: "tipp" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_PasswordInput = _resolveComponent("PasswordInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FixedHeaderTop = _resolveComponent("FixedHeaderTop")!
  const _component_Snackbar = _resolveComponent("Snackbar")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showUserCreated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_PageHeader, { defaultHeader: true }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('header.create')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createElementVNode("form", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('form.firstName')) + "*", 1),
                _withDirectives(_createElementVNode("input", {
                  name: "firstName",
                  type: "text",
                  placeholder: _ctx.$t('form.firstName')+ '*',
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstName) = $event)),
                  autocomplete: "off"
                }, null, 8, _hoisted_6), [
                  [_vModelText, _ctx.form.firstName]
                ]),
                (_ctx.getErrorClass('string', _ctx.form.firstName)=='required')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('error.required')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getErrorClass('string', _ctx.form.firstName)=='toShort')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('error.too_short')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('form.lastName')) + "*", 1),
                _withDirectives(_createElementVNode("input", {
                  name: "lastName",
                  type: "text",
                  placeholder: _ctx.$t('form.lastName')+ '*',
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.lastName) = $event)),
                  autocomplete: "off"
                }, null, 8, _hoisted_11), [
                  [_vModelText, _ctx.form.lastName]
                ]),
                (_ctx.getErrorClass('string', _ctx.form.lastName)=='required')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('error.required')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getErrorClass('string', _ctx.form.lastName)=='toShort')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('error.too_short')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('form.username')) + "*", 1),
                _withDirectives(_createElementVNode("input", {
                  name: "email",
                  type: "email",
                  placeholder: _ctx.$t('form.username')+ '*',
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.username) = $event)),
                  autocomplete: "off"
                }, null, 8, _hoisted_16), [
                  [_vModelText, _ctx.form.username]
                ]),
                (_ctx.getErrorClass('email', _ctx.form.username)=='required')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('error.required')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getErrorClass('email', _ctx.form.username)=='wrongMail')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('error.wrongMail')), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('form.password')) + "*", 1),
                _createVNode(_component_PasswordInput, {
                  placeholder: _ctx.$t('form.password')+ '*',
                  onOnChange: _cache[3] || (_cache[3] = (value) => _ctx.form.password = value)
                }, null, 8, ["placeholder"]),
                (_ctx.getErrorClass('password', _ctx.form.password)=='required')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('error.required')), 1))
                  : (_ctx.getErrorClass('password', _ctx.form.password)=='toShort')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$t('error.pw_too_short')), 1))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('form.passwordRepeat')) + "*", 1),
                _createVNode(_component_PasswordInput, {
                  placeholder: _ctx.$t('form.passwordRepeat')+ '*',
                  onOnChange: _cache[4] || (_cache[4] = (value) => _ctx.passwordrepeat = value)
                }, null, 8, ["placeholder"]),
                (_ctx.getErrorClass('passwordRepeat', _ctx.passwordrepeat)=='required')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('error.required')), 1))
                  : _createCommentVNode("", true),
                (_ctx.getErrorClass('passwordRepeat', _ctx.passwordrepeat)=='dontMatch')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('error.dontMatch')), 1))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.registrationCodePreselected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "code",
                        name: "code",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.iHaveACode) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.iHaveACode]
                      ]),
                      _createElementVNode("label", null, _toDisplayString(_ctx.$t('form.iHaveARegistrationCode')), 1)
                    ]),
                    (_ctx.iHaveACode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('form.enterCode')), 1),
                          _withDirectives(_createElementVNode("input", {
                            name: "code",
                            type: "text",
                            placeholder: _ctx.$t('form.enterCode'),
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.registrycode) = $event)),
                            autocomplete: "off"
                          }, null, 8, _hoisted_31), [
                            [_vModelText, _ctx.form.registrycode]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "privacy",
                  name: "privacy",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.privacy) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.privacy]
                ]),
                _createElementVNode("label", null, [
                  _hoisted_33,
                  _createElementVNode("a", {
                    href: "/privacy",
                    onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openPrivacyPopup && _ctx.openPrivacyPopup(...args)), ["prevent"])),
                    target: (_ctx.webviewMode ? '_top' : '_blank'),
                    class: "bold"
                  }, "Datenschutzbestimmungen", 8, _hoisted_34),
                  _hoisted_35,
                  _hoisted_36,
                  (_ctx.getErrorClass('check', _ctx.form.privacy)=='required')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t('error.privacyCheck')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "terms",
                  name: "terms",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.terms) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.terms]
                ]),
                _createElementVNode("label", null, [
                  _hoisted_39,
                  _createElementVNode("a", {
                    onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openTermsPopup && _ctx.openTermsPopup(...args)), ["prevent"])),
                    href: "https://www.alprelax.at/wp-content/uploads/2023/04/agb-alprelax.pdf",
                    target: "_blank",
                    class: "bold"
                  }, "Allgemeinen Geschäftsbedingungen"),
                  _hoisted_40,
                  _hoisted_41,
                  (_ctx.getErrorClass('check', _ctx.form.terms)=='required')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.$t('error.termsCheck')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "newsletter",
                  name: "newsletter",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.newsletter) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.newsletter]
                ]),
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('newsletterCheck')), 1)
              ]),
              _hoisted_44,
              _createVNode(_component_Button, {
                text: _ctx.$t('button.register'),
                waitForResponse: _ctx.waitForResponse,
                onHandleClicked: _ctx.handleSubmitForm
              }, null, 8, ["text", "waitForResponse", "onHandleClicked"]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('already_registered')) + "?", 1),
                _createVNode(_component_router_link, {
                  to: "/loginform",
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('login_now')), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createVNode(_component_FixedHeaderTop, { maxWidth: 48 }),
          _createVNode(_component_PageHeader, { defaultHeader: true }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t('header.userCreated')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('submitMail')), 1),
            _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('submitMailTipp')), 1)
          ])
        ])),
    _createVNode(_component_Snackbar, {
      show: _ctx.snackbar.show,
      text: _ctx.snackbar.text,
      error: _ctx.snackbar.error
    }, null, 8, ["show", "text", "error"]),
    (_ctx.showPopup)
      ? (_openBlock(), _createBlock(_component_Popup, {
          key: 2,
          uri: _ctx.contentUri,
          onOnClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showPopup = false))
        }, null, 8, ["uri"]))
      : _createCommentVNode("", true)
  ]))
}